module.exports = __webpack_public_path__ + "static/media/node.43816d99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Skillset/icon/node.jpg
// module id = 51
// module chunks = 0